//
import GAuthorizationModel from '@/models/General/GAuthorization'

//
export default class GAuthorizationService {

  /**
   * Get the bar authorization data by provided code
   * @param {*} code 
   * @return {Promise}
   */
  static getBarByCode(code) {
    return this
      .model()
      .custom('bar_authorization')
      .params({
        auth_code: code,
        permission: 'access_to%20point_sale',
      })
      .get()
  }

  /**
   * Get the authorization data by provided code
   * @param {*} code 
   * @return {Promise}
   */
  static getByCode(code) {
    return this
      .model()
      .params({
        auth_code: code,
        permission: 'access_to%20point_sale',
      })
      .get()
  }

  /**
   *  Returns the model
   */
  static model() {
    return GAuthorizationModel
  }
}